import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControlConfirmationList extends BaseModelAPI {

	static entity = 'partpurchasequalitycontrolconfirmationlist'
	static entityName = 'partpurchasequalitycontrolconfirmation';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
